(() => {
  const intervals = new Map();

  function initCountdowns() {
    document.querySelectorAll('[data-announcement-countdown]').forEach((el) => {
      if (intervals.has(el)) return;

      const endTime = Date.parse(el.dataset.endDate);
      if (Number.isNaN(endTime)) return;

      const fields = {
        days: el.querySelector('[data-countdown-days]'),
        hours: el.querySelector('[data-countdown-hours]'),
        minutes: el.querySelector('[data-countdown-minutes]'),
        seconds: el.querySelector('[data-countdown-seconds]')
      };

      const format = (number) => String(number).padStart(2, '0');

      const update = () => {
        if (!el.isConnected) {
          clearInterval(intervals.get(el));
          intervals.delete(el);
          return;
        }

        const remaining = Math.max(0, endTime - Date.now());

        if (remaining === 0) {
          clearInterval(intervals.get(el));
          intervals.delete(el);

          if (el.dataset.hideAfterEnd === 'true') {
            const message = el.closest('.announcement-bar__message');
            const bar = el.closest('.announcement-bar');

            if (bar?.tagName.toLowerCase() === 'slideshow-component') {
              const slide = el.closest('.slideshow__slide');
              if (slide) {
                slide.querySelector('.announcement-bar__message').textContent =
                  'The new prices are now in effect';
              }
            } else {
              bar?.closest('.utility-bar')?.remove();
            }
          } else {
            el.hidden = true;
          }

          return;
        }

        fields.days.textContent = format(Math.floor(remaining / 86400000));
        fields.hours.textContent = format(Math.floor((remaining / 3600000) % 24));
        fields.minutes.textContent = format(Math.floor((remaining / 60000) % 60));
        fields.seconds.textContent = format(Math.floor((remaining / 1000) % 60));

        el.hidden = false;
      };

      update();

      if (intervals.has(el)) return;
      intervals.set(el, setInterval(update, 1000));
    });
  }

  document.addEventListener('DOMContentLoaded', initCountdowns);
  document.addEventListener('shopify:section:load', initCountdowns);

  if (document.readyState !== 'loading') initCountdowns();
})();